import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Radio, Tag } from 'antd';
import { Enumify } from "enumify-ts";
class UserType extends Enumify() {
    description;
    colour;
    static ADMIN = new UserType("Administration", "blue");
    static API = new UserType("API", "green");
    static DRIVER = new UserType("Driver", "purple");
    static _ = UserType._closeEnum();
    constructor(description, colour) {
        super();
        this.description = description;
        this.colour = colour;
    }
    renderTag() {
        return _jsx(Tag, { color: this.colour, children: this.description });
    }
    static filtersArray() {
        let a = [];
        for (let t of UserType.values) {
            a.push({ text: t.description, value: t.key });
        }
        return a;
    }
    static radioButtonsArray() {
        let a = [];
        for (let t of UserType.values) {
            a.push(_jsx(Radio.Button, { value: t.key, children: t.description }, t.key));
        }
        return a;
    }
}
export default UserType;
